module.exports = __webpack_public_path__ + "static/img/1-3.cee431dc.jpg";